import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../Common/Footer';
import { SideBar } from '../Common/SideBar';
import { DashboardHeader } from '../Common/DashboardHeader';
import Profile from '../../Models/Profile';
import { Header } from '../Common';
import Common from "../../Models/Common";
class SellerPortfolioAll extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '') {
            alert(this.props.t('0'))
            this.props.history.push('/login/seller');
        };
        // console.log(logged_user)
        this.state = {
            _id: false,
            portfolio: [],
            profile: [],
            personal: []
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        Profile.getServiceList(this.props.location.state.id).then(res => {
            if (res.data.payload != null) {
                this.setState({ services: res.data.payload })
            }
        })
        // Profile.getPortfolio(this.props.location.state.id).then(res => {
        //     if (res.data.payload != null) {
        //         this.setState({ portfolio: res.data.payload })
        //     }
        // })
        Profile.getProfile(this.props.location.state.id).then(res => {
            if (res.data.profile != null) {
                this.setState({ profile: res.data.profile })
                this.setState({ personal: res.data.personal })
            }
        })
        Profile.getPortfolioAll(this.props.location.state.id).then(res => {
            if (res.data.payload != null) {
                this.setState({ portfolio: res.data.payload })
            }
        })
    }

    details(details) {
        const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
        if (details === null || details === '') {
            return (
                renderHTML(details)
            )
        } else {
            return (
                renderHTML(details.substr(0, 100))
            )
        }
    }


    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //for mobile view
        if (isMobile) {
            return (
                <div  className="wrapper">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid main">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                <div className="input_name">
                                    <div>
                                        <img className="rounded-circle" alt="" src={this.state.profile.img} width="140" height="140" style={{ objectFit: 'cover' }} />
                                    </div>
                                    <div className="top_bottom_paddings">
                                        <span className="profile_name"> {this.state.personal.first_name} </span>
                                    </div>
                                    <div className="mt-5 mb-3 input_name content_dertails guide_text" style={{ width: '100%' }}>
                                        {this.props.t('3')}
                                    </div>
                                    <fieldset className="fieldset_border">
                                        <legend className="fieldset_legend" style={{ width: "15%", }}>{this.props.t('9')}</legend>
                                        <span><div className="pb-1">{this.state.profile.profession}</div></span>
                                    </fieldset>
                                    <br/>
                                    <fieldset className="fieldset_border">
                                        <legend className="fieldset_legend" style={{ width: "15%", }}>{this.props.t('10')}</legend>
                                        <span><div className="pb-1">{this.state.profile.description}</div></span>
                                    </fieldset>
                                    <br/>
                                    <fieldset className="fieldset_border">
                                        <legend className="fieldset_legend" style={{ width: "35%", }}>{this.props.t('5')}</legend>
                                        <span><div className="pb-1">{this.state.profile.area}</div></span>
                                    </fieldset>
                                    <br/>
                                    <fieldset className="fieldset_border">
                                        <legend className="fieldset_legend" style={{ width: "15%", }}>{this.props.t('11')}</legend>
                                        <span><div className="pb-1" style={{textAlign:"left"}}>{this.state.profile.address}</div></span>
                                    </fieldset>
                                </div>
                            </div> */}
                            <div className="col-md-8">
                                <div className="mt-5  input_name big_font text-left" style={{ width: '100%', fontSize: '20px' }}>{this.props.t('1')}</div>
                                {(() => {
                                    if (this.state.portfolio.length === 0) {
                                        return (
                                            <div></div>
                                        )
                                    } else {
                                        return (
                                            <div style={{ border: "1px solid #bababa", minHeight: "550px", padding: "2%", textAlign: "center" }}>
                                                {this.state.portfolio.map(group =>
                                                    <div className="service-list-divs" key={group.id}>
                                                        <div className="row">
                                                            <div className="col-md-9">
                                                                <div className="row pb-2 pt-2">
                                                                    <div className="col-8" style={{ textAlign: "left" ,color:"cornflowerblue"}}>
                                                                        <div style={{display: "none"}}>{group.cat_name}</div>
                                                                    </div>
                                                                    <div className="col-4" style={{ textAlign: "right" }}>
                                                                        {group.updated_at.substr(0,11)}
                                                                    </div>
                                                                </div>
                                                                <div className="row pb-2">
                                                                    <div className="col-md-8" style={{ textAlign: "left" }}>
                                                                        <Link to={{
                                                                            pathname: `/portfolio-details/${group.id}`
                                                                        }}>
                                                                            {group.title}
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-md-8" style={{ textAlign: "left" }}>
                                                                        {group.trimmed_details}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <img alt="" src={Common.baseUrl + group.img} height="200" width="100%" style={{ objectFit:'cover' }}></img>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )
                                    }
                                })()}
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div className="wrapper">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid main">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <div className="input_name">
                                            <div>
                                                <img className="rounded-circle" alt="" src={Common.baseUrl + this.state.profile.img} width="140" height="140" style={{ objectFit: 'cover' }} />
                                            </div>
                                            <div className="top_bottom_paddings">
                                                <span className="profile_name"> {this.state.personal.first_name} </span>
                                            </div>

                                            <div className="mb-1 input_name content_dertails text-left">
                                                {this.props.t('3')}
                                        </div>
                                            {/* <div className="col-md-8" style={{ border: "1px solid #f1f0ee", padding: "4%", textAlign: "center", height: "200px" }}> */}
                                            <div className=" row">
                                                <div className="col-md-4" style={{ textAlign: "right" }}>
                                                    <b><i>{this.props.t('9')}:</i></b>
                                                </div>
                                                <div className="col-md-1"></div>
                                                <div className="col-md-7" style={{ textAlign: "left" }}>
                                                    {this.state.profile.profession}
                                                </div>
                                            </div>
                                            <div className=" row">
                                                <div className="col-md-4" style={{ textAlign: "right" }}>
                                                    <b><i>{this.props.t('10')}:</i></b>
                                                </div>
                                                <div className="col-md-1"></div>
                                                <div className="col-md-7" style={{ textAlign: "left" }}>
                                                    {this.state.profile.description}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4" style={{ textAlign: "right" }}>
                                                    <b><i>{this.props.t('5')}:</i></b>
                                                </div>
                                                <div className="col-md-1"></div>
                                                <div className="col-md-7" style={{ textAlign: "left" }}>
                                                    {this.state.profile.area}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4" style={{ textAlign: "right" }}>
                                                    <b><i>{this.props.t('11')}:</i></b>
                                                </div>
                                                <div className="col-md-1"></div>
                                                <div className="col-md-7" style={{ textAlign: "left" }}>
                                                    {this.state.profile.address}
                                                </div>
                                            </div>
                                            {/* </div> */}


                                        </div>
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mb-1 input_name big_font text-left">
                                            {this.props.t('1')}
                                    </div>
                                        {(() => {
                                            if (this.state.portfolio.length === 0) {
                                                return (
                                                    <div></div>
                                                )
                                            } else {
                                                return (
                                                    <div style={{ border: "1px solid #bababa", minHeight: "550px", padding: "2%", textAlign: "center" }}>
                                                        {this.state.portfolio.map(group =>
                                                            <div className="service-list-divs" key={group.id}>
                                                                <div className=" row">
                                                                    <div className="col-md-3">
                                                                        <img alt="" src={Common.baseUrl + group.img} style={{ width: "100%" }}></img>
                                                                    </div>
                                                                    <div className="col-md-9">
                                                                        <div className=" row">
                                                                            <div className="col-md-3" style={{ textAlign: "right" }}>
                                                                                <b><i>{this.props.t('8')}:</i></b>
                                                                            </div>
                                                                            <div className="col-md-8" style={{ textAlign: "left" }}>
                                                                                <Link to={{
                                                                                    pathname: `/portfolio-details/${group.id}`
                                                                                }}>
                                                                                    {group.title}
                                                                                </Link>
                                                                            </div>
                                                                        </div>
                                                                        <div className=" row">
                                                                            <div className="col-md-3" style={{ textAlign: "right" }}>
                                                                                <b><i>{this.props.t('15')}:</i></b>
                                                                            </div>
                                                                            <div className="col-md-8" style={{ textAlign: "left" }}>
                                                                                {group.trimmed_details}
                                                                                {/* {group.details.split('\n').map(function (item, key) {
                                                                                    return (
                                                                                        <span key={key}>
                                                                                            {item}
                                                                                            <br />
                                                                                        </span>
                                                                                    )
                                                                                })} */}
                                                                            </div>
                                                                        </div>
                                                                        <div className=" row" style={{display: "none"}}>
                                                                            <div className="col-md-3" style={{ textAlign: "right" }}>
                                                                                <b><i>{this.props.t('7')}:</i></b>
                                                                            </div>
                                                                            <div className="col-md-8" style={{ textAlign: "left" }}>
                                                                                {group.cat_name}
                                                                            </div>
                                                                        </div>
                                                                        <div className=" row">
                                                                            <div className="col-md-3" style={{ textAlign: "right" }}>
                                                                                <b><i>{this.props.t('16')}:</i></b>
                                                                            </div>
                                                                            <div className="col-md-8" style={{ textAlign: "left" }}>
                                                                                {group.updated_at.substr(0,11)}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )
                                            }
                                        })()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
export { SellerPortfolioAll }


 SellerPortfolioAll = withTranslation('src_Components_Profile_SellerPortfolioAll')(SellerPortfolioAll);
